import { useContract, useContractParam } from './common';
import { useWeb3React } from './web3';
import { contracts } from 'web3/utils/contracts';

export function useRel() {
  return useContract('REL', contracts.REL.address);
}

export function useSRel() {
  return useContract('sREL', contracts.sREL.address);
}

export function useRelBalance() {
  const { account } = useWeb3React();
  useRelParam('balanceOf', [account]);
}

export function useSRelBalance() {
  const { account } = useWeb3React();
  useSRelParam('balanceOf', [account]);
}

export function useRelParam(param, args) {
  const contract = useRel();
  return useContractParam(contract, param, args);
}

export function useSRelParam(param, args) {
  const contract = useSRel();
  return useContractParam(contract, param, args);
}
